// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "footer__inner-3rh-7";
export { _1 as "__esModule", _2 as "footer__inner" }
export default { "__esModule": _1, "footer__inner": _2 }
